export default __webpack_public_path__ + "static/meeting-9791a12b1da8e5e7f6ba0edf8e7b00df.jpg";